import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FocusMeDirective } from './directives/focus-me.directive';
import { MustMatchDirective } from './directives/must-match.directive';
import { DirtyTrackingDirective } from './directives/dirty-tracking.directive';
import { ConfirmComponent } from './components/confirm/confirm.component';
import { FormsModule } from '@angular/forms';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { YesNoCancelComponent } from './components/yes-no-cancel/yes-no-cancel.component';
import { NotificationComponent } from './components/notification/notification.component';
import { MessageComponent } from './components/message/message.component';
import { ErrorMessageComponent } from './components/error-message/error-message.component';
import { CustomFileUploadComponent } from './components/custom-file-upload/custom-file-upload.component';
import { LocalDatePipe, LocalDateTimePipe, PrettyDatePipe } from './pipes/dates.model';

@NgModule({
  declarations: [
    FocusMeDirective,
    MustMatchDirective,
    DirtyTrackingDirective,
    ConfirmComponent,
    YesNoCancelComponent,
    NotificationComponent,
    MessageComponent,
    ErrorMessageComponent,
    CustomFileUploadComponent,
    LocalDatePipe,
    LocalDateTimePipe,
    PrettyDatePipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgbModalModule,
    FontAwesomeModule
  ],
  providers: [
    DatePipe
  ],
  exports: [
    FocusMeDirective,
    MustMatchDirective,
    DirtyTrackingDirective,
    ErrorMessageComponent,
    CustomFileUploadComponent,
    LocalDatePipe,
    LocalDateTimePipe,
    PrettyDatePipe
  ],
})
export class CoreModule { }
